export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 3_04.5b884f99.jpg";